import { useState } from 'react'
import { ScrollArea } from '@/components/ui/scroll-area'
import { BasicSettingsSection } from './BasicSettingsSection'
import { ColorsSection } from './ColorsSection'
import { AvatarSettingsSection } from './AvatarSettingsSection'
import { FeaturesSection } from './FeaturesSection'
import type { WidgetConfiguration } from '../../types'

interface WidgetSettingsProps {
  config: WidgetConfiguration
  onUpdate: (updates: Partial<WidgetConfiguration>) => void
}

export function WidgetSettings({ config, onUpdate }: WidgetSettingsProps) {
  const [openSections, setOpenSections] = useState({
    basic: true,
    colors: false,
    avatars: false,
    features: false,
  })

  const toggleSection = (section: keyof typeof openSections) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }))
  }

  return (
    <ScrollArea className="h-full pr-4">
      <div className="space-y-4">
        <BasicSettingsSection
          config={config}
          onUpdate={onUpdate}
          isOpen={openSections.basic}
          onToggle={() => toggleSection('basic')}
        />

        <ColorsSection
          config={config}
          onUpdate={onUpdate}
          isOpen={openSections.colors}
          onToggle={() => toggleSection('colors')}
        />

        <AvatarSettingsSection
          config={config}
          onUpdate={onUpdate}
          isOpen={openSections.avatars}
          onToggle={() => toggleSection('avatars')}
        />

        <FeaturesSection
          config={config}
          onUpdate={onUpdate}
          isOpen={openSections.features}
          onToggle={() => toggleSection('features')}
        />
      </div>
    </ScrollArea>
  )
}
